import { useMemo } from 'react';

export const getScaleScoreUnit = (areaIdentifier: string): string => {
  switch (areaIdentifier) {
    case 'math':
      return 'patm';
    case 'comp':
      return 'patc';
    case 'vocab':
      return 'patv';
    case 'listening':
      return 'patl';
    case 'pg':
      return 'patpg';
    case 'star':
      return 'star';
    case 'jstwe':
      return 'patjs';
    case 'stwe':
      return 'patss';
    case 'trm':
      return 'TRM';
    case 'w@s':
      return 'wbs';
    default:
      return '';
  }
};

export const useTestScaleScoreUnit = (areaIdentifier: string): string => {
  const scaleScoreUnit = useMemo(() => getScaleScoreUnit(areaIdentifier), [areaIdentifier]);

  return scaleScoreUnit;
};

export default useTestScaleScoreUnit;
